'use client'

import useReadMineUserQueryWhenLogin from '@/hooks/use-read-mine-user-query-when-login'

import LineArrow from '../images/line-arrow.svg'

import Betting from './betting'
import Content from './content'
import Ranking from './ranking'

export interface CompetitionProps {
  id: number
}

export default function CompetitionDetails({ id }: CompetitionProps) {
  const { data: mineUser, refetch: refetchMineUser } = useReadMineUserQueryWhenLogin()
  const isApplied =
    mineUser !== undefined &&
    mineUser.competitions.some((competition) => competition.id === id)

  return (
    <>
      <div className="w-[85rem] mx-auto py-12 px-10 mt-7 flex gap-12 rounded-3xl border border-white/12 bg-white/4 backdrop-blur-[100px]">
        <div className="size-[36rem] rounded-full absolute top-[8.5rem] left-[1.5rem] bg-linear-to-bl from-[#3E5DF6]/70 from-33% to-[#242F60]/70 to-91% blur-[50px]" />
        <div className="size-[34.25rem] rounded-full absolute bottom-[6rem] right-[17.125rem] bg-linear-to-b from-[#2E48CA]/40 from-33% to-[#242F60]/40 to-91% blur-[50px]" />
        <Ranking id={id} mineUserId={mineUser?.id} />
        <Betting id={id} />
      </div>

      <div className="flex my-24">
        <div className="flex-1 border-t border-white/20" />
        <LineArrow />
        <div className="flex-1 border-t border-white/20" />
      </div>
      <Content
        isApplied={isApplied}
        refetchMineUser={refetchMineUser}
        id={id}
      />
    </>
  )
}
